(function () {
  var r = document.querySelector('.cdx[data-unit]');
  if (!r || r.dataset.init) return;
  r.dataset.init = '1';
  r.classList.add('cdx-js');

  var D = r.dataset;
  var unit = +D.unit, cmp = +D.cmp, pid = +D.pid, cartUrl = D.cart || '/cart';
  var tot = { 1: unit, 2: +D.lot2, 3: +D.lot3 };
  var q = 2, busy = false, lastFocus = null, closeTimer = null;

  function $(s, c) { return (c || r).querySelector(s); }
  function $$(s, c) { return [].slice.call((c || r).querySelectorAll(s)); }
  function fmt(c) {
    try { return (c / 100).toLocaleString(D.locale || 'fr', { style: 'currency', currency: D.currency || 'EUR' }); }
    catch (e) { return (c / 100).toFixed(2) + ' €'; }
  }
  function show(el, on) { if (el) el.hidden = !on; }

  var track = $('[data-track]'), colors = $('[data-colors]'), tpl = $('template[data-opt]');
  var up = $('[data-up]'), upId = up ? +up.dataset.up : 0, upPrice = up ? +up.dataset.price : 0;
  var opt = tpl ? tpl.innerHTML : '', thumbs = $$('[data-go]'), sws = $$('.cdx-sw');
  var drawer = $('[data-drawer]'), panel = $('.cdx-panel'), lineTpl = $('template[data-line]');
  var err = $('[data-err]'), derr = $('[data-derr]');

  /* ---------- Galerie ---------- */
  function slides() { return track ? [].slice.call(track.children) : []; }
  function current() { return track && track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0; }
  function go(i) {
    var s = slides();
    if (!s.length) return;
    i = Math.max(0, Math.min(s.length - 1, i));
    track.scrollTo({ left: s[i].offsetLeft, behavior: 'smooth' });
  }
  function mark() {
    var i = current(), idx = $('[data-idx]');
    thumbs.forEach(function (b, j) { b.classList.toggle('is-on', j === i); });
    if (idx) idx.textContent = i + 1;
  }
  if (track) {
    var tick;
    track.addEventListener('scroll', function () { clearTimeout(tick); tick = setTimeout(mark, 80); });
  }
  thumbs.forEach(function (b) { b.addEventListener('click', function () { go(+b.dataset.go); }); });
  var prev = $('[data-prev]'), next = $('[data-next]');
  if (prev) prev.addEventListener('click', function () { go(current() - 1); });
  if (next) next.addEventListener('click', function () { go(current() + 1); });

  /* ---------- Couleurs et lots ---------- */
  function sels() { return $$('select', colors); }
  function build() {
    var cur = sels().map(function (s) { return s.value; }), h = '';
    for (var i = 0; i < q; i++) h += '<label><span>' + D.item + ' ' + (i + 1) + '</span><select>' + opt + '</select></label>';
    colors.innerHTML = h;
    sels().forEach(function (s, i) {
      var v = cur[i] || cur[0] || D.first;
      if (v) s.value = v;
      if (s.selectedIndex < 0 || (s.options[s.selectedIndex] && s.options[s.selectedIndex].disabled)) {
        for (var k = 0; k < s.options.length; k++) if (!s.options[k].disabled) { s.selectedIndex = k; break; }
      }
      s.addEventListener('change', function () { if (i === 0) pick(s.value, true); });
    });
    colors.hidden = q < 2;
  }
  function pick(vid, fromSelect) {
    var s = sels()[0];
    if (s && !fromSelect) s.value = vid;
    sws.forEach(function (b) {
      var on = b.dataset.vid == vid;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on) {
        var n = $('[data-cname]');
        if (n) n.textContent = b.dataset.name;
        slides().forEach(function (sl, i) { if (sl.dataset.mid == b.dataset.mid) go(i); });
      }
    });
  }
  function total() { return tot[q] + (up && up.checked ? upPrice : 0); }
  function paint() {
    $$('[data-cta-p]').forEach(function (e) { e.textContent = fmt(total()); });
    $$('[data-tier]').forEach(function (t) {
      var on = +t.dataset.tier === q;
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  $$('[data-m]').forEach(function (e) { e.textContent = fmt(+e.dataset.m); });
  $$('[data-tier]').forEach(function (t) { t.addEventListener('click', function () { q = +t.dataset.tier; build(); paint(); }); });
  sws.forEach(function (b) { b.addEventListener('click', function () { pick(b.dataset.vid); }); });
  if (up) up.addEventListener('change', paint);

  /* ---------- Date de livraison estimée ---------- */
  (function () {
    var e = $('[data-eta]');
    if (!e) return;
    var a = +e.dataset.min, b = +e.dataset.max;
    if (!a || !b || b < a) return;
    function biz(n) {
      var x = new Date();
      while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; }
      return x.toLocaleDateString(D.locale || 'fr', { day: 'numeric', month: 'long' });
    }
    $('[data-eta-a]', e).textContent = biz(a);
    $('[data-eta-b]', e).textContent = biz(b);
    e.hidden = false;
  })();

  /* ---------- Panier ---------- */
  function api(path, body) {
    return fetch(cartUrl + path, {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (x) {
      return x.json().catch(function () { return {}; }).then(function (j) {
        if (!x.ok) throw new Error(j.description || j.message || 'Une erreur est survenue. Merci de réessayer.');
        return j;
      });
    });
  }
  function fail(el, e) {
    if (!el) return;
    el.textContent = (e && e.message && e.message !== 'Failed to fetch') ? e.message : 'Une erreur est survenue. Merci de réessayer.';
    el.hidden = false;
  }
  function setBusy(on) {
    busy = on;
    r.classList.toggle('is-busy', on);
    $$('[data-cta]').forEach(function (b) { if (b.tagName === 'BUTTON' && !D.soldout) b.disabled = on; });
  }
  function bubble(n) {
    $$('[ref=cartBubbleCount]', document).forEach(function (e) { e.textContent = n < 100 ? n : ''; e.classList.toggle('hidden', n === 0); });
    $$('[ref=cartBubble]', document).forEach(function (e) { e.classList.toggle('visually-hidden', n === 0); });
    try { sessionStorage.setItem('cart-count', JSON.stringify({ value: String(n), timestamp: Date.now() })); } catch (e) {}
  }
  function render(c) {
    var ul = $('[data-lines]'), pq = 0, ptotal = 0, firstV = 0, hasUp = false;
    ul.innerHTML = '';
    (c.items || []).forEach(function (it) {
      var li = lineTpl.content.firstElementChild.cloneNode(true), img = $('img', li);
      if (it.image) img.src = it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160'; else img.remove();
      $('[data-t]', li).textContent = it.product_title;
      $('[data-v]', li).textContent = it.product_has_only_default_variant ? '' : (it.variant_title || '');
      $('[data-d]', li).textContent = (it.line_level_discount_allocations || []).map(function (a) { return a.discount_application.title; }).join(', ');
      $('[data-q]', li).textContent = it.quantity;
      $('[data-p]', li).textContent = fmt(it.final_line_price);
      $('[data-o]', li).textContent = it.original_line_price > it.final_line_price ? fmt(it.original_line_price) : '';
      $('[data-dec]', li).addEventListener('click', function () { change(it.key, it.quantity - 1); });
      $('[data-inc]', li).addEventListener('click', function () { change(it.key, it.quantity + 1); });
      $('[data-rm]', li).addEventListener('click', function () { change(it.key, 0); });
      if (it.product_id === pid) { pq += it.quantity; ptotal += it.final_line_price; if (!firstV) firstV = it.variant_id; }
      if (upId && it.variant_id === upId) hasUp = true;
      ul.appendChild(li);
    });
    var n = c.item_count || 0, empty = n === 0;
    $('[data-count]').textContent = empty ? '' : '(' + n + ')';
    show($('[data-empty]'), empty);
    show($('[data-foot]'), !empty);
    show($('.cdx-ship'), !empty);
    $('[data-total]').textContent = fmt(c.total_price || 0);
    var saved = pq * cmp - ptotal;
    show($('[data-save]'), saved > 0);
    $('[data-save-v]').textContent = fmt(saved);
    var nudge = $('[data-nudge]'), gain = pq === 1 ? 2 * unit - tot[2] : (pq === 2 ? tot[2] + unit - tot[3] : 0);
    if (nudge) {
      show(nudge, gain > 0 && firstV);
      if (gain > 0 && firstV) {
        $('[data-nudge-t]').textContent = (pq === 1 ? nudge.dataset.t2 : nudge.dataset.t3).replace('{x}', fmt(gain));
        $('[data-nudge-b]').onclick = function () { addItems([{ id: firstV, quantity: 1 }], derr); };
      }
    }
    show($('[data-dup]'), upId && !hasUp && !empty);
    bubble(n);
  }
  function load() { return api('.js').then(function (c) { render(c); return c; }); }
  function change(key, qty) {
    if (busy) return;
    setBusy(true); show(derr, false);
    api('/change.js', { id: key, quantity: qty }).then(render).catch(function (e) { fail(derr, e); return load().catch(function () {}); }).then(function () { setBusy(false); });
  }
  function addItems(items, errEl) {
    if (busy) return Promise.resolve();
    setBusy(true); show(err, false); show(derr, false);
    return api('/add.js', { items: items }).then(load).then(openDrawer).catch(function (e) { fail(errEl || err, e); }).then(function () { setBusy(false); });
  }
  function addSelection() {
    if (D.soldout) return;
    var m = {}, items = [];
    sels().forEach(function (s) { if (s.value) m[s.value] = (m[s.value] || 0) + 1; });
    Object.keys(m).forEach(function (k) { items.push({ id: +k, quantity: m[k] }); });
    if (!items.length) return;
    if (up && up.checked) items.push({ id: upId, quantity: 1 });
    addItems(items, err);
  }
  $$('[data-cta]').forEach(function (b) { if (b.tagName === 'BUTTON') b.addEventListener('click', addSelection); });
  var dupB = $('[data-dup-b]');
  if (dupB) dupB.addEventListener('click', function () { addItems([{ id: upId, quantity: 1 }], derr); });

  /* ---------- Tiroir ---------- */
  function openDrawer() {
    if (!drawer) return;
    clearTimeout(closeTimer);
    if (drawer.hidden) lastFocus = document.activeElement;
    drawer.hidden = false;
    document.documentElement.classList.add('cdx-lock');
    requestAnimationFrame(function () { drawer.classList.add('is-open'); panel.focus(); });
  }
  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('cdx-lock');
    closeTimer = setTimeout(function () { drawer.hidden = true; }, 260);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  $$('[data-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  document.addEventListener('keydown', function (e) {
    if (!drawer || drawer.hidden) return;
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key !== 'Tab') return;
    var f = $$('button, a[href]', panel).filter(function (x) { return !x.disabled && x.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1], a = document.activeElement;
    if (e.shiftKey && (a === first || a === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
  });
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest || r.contains(t)) return;
    var link = t.closest('a'), icon = t.closest('cart-icon');
    if (!icon && !(link && link.pathname === cartUrl)) return;
    e.preventDefault(); e.stopPropagation();
    load().then(openDrawer).catch(function () { window.location.href = cartUrl; });
  }, true);

  /* ---------- Barre fixe mobile et apparitions ---------- */
  var main = $('.cdx-buy [data-cta]'), st = $('[data-sticky]');
  function stick() { st.hidden = main.getBoundingClientRect().bottom > 0; }
  if (main && st) {
    window.addEventListener('scroll', stick, { passive: true });
    window.addEventListener('resize', stick);
    stick();
  }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } }); }, { rootMargin: '0px 0px -10% 0px' });
    $$('.cdx-rv').forEach(function (e) { io.observe(e); });
  } else {
    $$('.cdx-rv').forEach(function (e) { e.classList.add('is-in'); });
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) { setBusy(false); load().catch(function () {}); } });

  build(); paint(); mark();
  load().catch(function () {});
})();
